import React from "react";
import { getLanguageValue } from "locales/i18n";
import { PAGE_TYPE } from "enums";

import LoadingComponent from "commons/loading/Loading.component";

const VerifyPasswordEmailComponent = (props: any) => {
  const {
    isVerify,
    password,
    setPassword,
    confirmedPassword,
    setConfirmedPassword,
    onClickBtnUpdatePassword,
    btnRef,
  } = props;

  return (
    <main className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      {typeof isVerify !== "boolean" ? (
        <LoadingComponent />
      ) : isVerify ? (
        <div className="max-w-md w-full bg-white rounded-xl shadow-md p-8 space-y-6">
          <h2 className="text-center text-2xl font-bold text-gray-900">
            {getLanguageValue(
              PAGE_TYPE.COMMON,
              "verifyPasswordEmail.txtResetPassword"
            )}
          </h2>

          <div className="space-y-4">
            <div className="relative">
              <input
                type="password"
                value={password}
                onChange={(evt) => setPassword(evt.target.value)}
                placeholder={getLanguageValue(
                  PAGE_TYPE.COMMON,
                  "verifyPasswordEmail.txtEnterPassword"
                )}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#CF3688] focus:border-[#CF3688] transition-colors"
              />
            </div>
            <div className="relative">
              <input
                type="password"
                value={confirmedPassword}
                onChange={(evt) => setConfirmedPassword(evt.target.value)}
                placeholder={getLanguageValue(
                  PAGE_TYPE.COMMON,
                  "verifyPasswordEmail.txtReenterPassword"
                )}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#CF3688] focus:border-[#CF3688] transition-colors"
              />
            </div>
          </div>

          <div className="pt-2">
            <button
              ref={btnRef}
              onClick={(evt) => onClickBtnUpdatePassword()}
              className="w-full flex justify-center py-3 px-4 border border-transparent rounded-lg shadow-sm text-white bg-[#CF3688] hover:bg-[#B82F77] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#CF3688] transition-colors">
              {getLanguageValue(
                PAGE_TYPE.COMMON,
                "verifyPasswordEmail.btnSavePassword"
              )}
            </button>
          </div>
        </div>
      ) : null}
    </main>
  );
};

export default VerifyPasswordEmailComponent;
